import React from 'react';
import { Table, Card, Typography } from 'antd';
import {stringMixin, money} from "../../utils/strings";



const formatProbabilities = (analysis, prefix) => {
    const stringFormatter = prefix === 'percentile' ? (v)=>money(v, 0) : (v)=>`${(v*100).toFixed(2)}%`
  return Object.entries(analysis)
    .filter(([key]) => key.startsWith(prefix))
    .map(([key, value]) => ({
      key,
      metric: key.replace(`${prefix}_`, '').replace('_', ' '),
      probability: value,
        format: stringFormatter
    }));
};

const columns = [
  {
    title: 'Metric',
    dataIndex: 'metric',
    key: 'metric',
  },
  {
    title: 'Probability',
    dataIndex: 'probability',
    key: 'probability',
    render: (value, record) => record.format(value),
  },
];

const ScenarioProbability = ({ analysis }) => {
  const gmmData = formatProbabilities(analysis, 'gmm');
  const kdeData = formatProbabilities(analysis, 'kde');
  const percentileData = formatProbabilities(analysis, 'percentile');
  const thresholds = formatProbabilities(analysis, 'threshold');

  return (
    <div>
      <Card
          bordered={false}
          title={<Typography.Text>Thresholds</Typography.Text> }
      >
          <Table className={'mid'} columns={columns} dataSource={thresholds} pagination={false} />
      </Card>
      <Card
          bordered={false}
          title={<Typography.Text>Mixture Probs (Alt 1)</Typography.Text> }
      >
          <Table className={'mid'} columns={columns} dataSource={gmmData} pagination={false} />
      </Card>
      <Card
          bordered={false}
          title={<Typography.Text>Density Probs</Typography.Text> }
      >
          <Table className={'mid'} columns={columns} dataSource={kdeData} pagination={false} />
      </Card>
      <Card
          bordered={false}
          title={<Typography.Text>Percentiles</Typography.Text> }
      >
          <Table className={'mid'} columns={columns} dataSource={percentileData} pagination={false} />
      </Card>
    </div>
  );
};

export default ScenarioProbability;
